"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __values = this && this.__values || function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
      m = s && o[s],
      i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function next() {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sort = exports.loadFromStorage = exports.getCount = exports.getNear = exports.getWindow = exports.get = exports.merge = exports.findAndReplace = exports.find = void 0;

var unit_1 = require("./unit");

var units_1 = __importStar(require("./http/units"));

var units_2 = require("./storage/units"); // perhaps wrap these functions in a namespace


function find(uuid, units) {
  var e_1, _a;

  try {
    for (var units_3 = __values(units), units_3_1 = units_3.next(); !units_3_1.done; units_3_1 = units_3.next()) {
      var unit = units_3_1.value;

      if (uuid.equals(unit.uuid)) {
        return unit;
      }
    }
  } catch (e_1_1) {
    e_1 = {
      error: e_1_1
    };
  } finally {
    try {
      if (units_3_1 && !units_3_1.done && (_a = units_3.return)) _a.call(units_3);
    } finally {
      if (e_1) throw e_1.error;
    }
  }
}

exports.find = find;

function findAndReplace(unit, units) {
  for (var i = 0; i < units.length; i++) {
    if (units[i].uuid.equals(unit.uuid)) {
      units[i] = unit;
      return units;
    }
  }

  return units;
}

exports.findAndReplace = findAndReplace;
/**
 * Merge merges two sets of units into one, where the first parameter is the newer data and the second one contains the source
 * @param newUnits - The changes to be merge into the source
 * @param source  - The source array used
 */

function merge(newUnits, source) {
  for (var i = 0; i < newUnits.length; i++) {
    var replaced = false;

    for (var j = 0; j < source.length; j++) {
      if (newUnits[i].uuid.equals(source[j].uuid)) {
        source[j] = newUnits[i];
        replaced = true;
      }
    }

    if (!replaced) {
      source.push(newUnits[i]);
    }
  }

  return source;
}

exports.merge = merge;

function get(credentials, time, fields, limitExpression) {
  if (limitExpression === void 0) {
    limitExpression = "";
  }

  return units_1.default(time, limitExpression, fields, credentials).then(function (resp) {
    var e_2, _a;

    var ret = [];

    try {
      for (var resp_1 = __values(resp), resp_1_1 = resp_1.next(); !resp_1_1.done; resp_1_1 = resp_1.next()) {
        var d = resp_1_1.value;
        ret.push(unit_1.decodeUnit(d));
      } // Not currently testable

    } catch (e_2_1) {
      e_2 = {
        error: e_2_1
      };
    } finally {
      try {
        if (resp_1_1 && !resp_1_1.done && (_a = resp_1.return)) _a.call(resp_1);
      } finally {
        if (e_2) throw e_2.error;
      }
    }

    return ret;
  });
}

exports.get = get;

function getWindow(credentials, fields, limit, offset, order, limitExpression) {
  if (offset === void 0) {
    offset = 0;
  }

  if (order === void 0) {
    order = "uuid";
  }

  if (limitExpression === void 0) {
    limitExpression = "";
  }

  return units_1.UnitsWindowed(limitExpression, fields, order, limit, offset, credentials).then(function (resp) {
    var e_3, _a;

    var ret = [];

    try {
      for (var resp_2 = __values(resp), resp_2_1 = resp_2.next(); !resp_2_1.done; resp_2_1 = resp_2.next()) {
        var d = resp_2_1.value;
        ret.push(unit_1.decodeUnit(d));
      } // Not currently testable

    } catch (e_3_1) {
      e_3 = {
        error: e_3_1
      };
    } finally {
      try {
        if (resp_2_1 && !resp_2_1.done && (_a = resp_2.return)) _a.call(resp_2);
      } finally {
        if (e_3) throw e_3.error;
      }
    }

    return ret;
  });
}

exports.getWindow = getWindow;

function getNear(credentials, fields, limit, offset, lat, lng, limitExpression) {
  if (offset === void 0) {
    offset = 0;
  }

  if (limitExpression === void 0) {
    limitExpression = "";
  }

  return units_1.UnitsNear(limitExpression, fields, lat, lng, limit, offset, credentials).then(function (resp) {
    var e_4, _a;

    var ret = [];

    try {
      for (var resp_3 = __values(resp), resp_3_1 = resp_3.next(); !resp_3_1.done; resp_3_1 = resp_3.next()) {
        var d = resp_3_1.value;
        ret.push(unit_1.decodeUnit(d));
      } // Not currently testable

    } catch (e_4_1) {
      e_4 = {
        error: e_4_1
      };
    } finally {
      try {
        if (resp_3_1 && !resp_3_1.done && (_a = resp_3.return)) _a.call(resp_3);
      } finally {
        if (e_4) throw e_4.error;
      }
    }

    return ret;
  });
}

exports.getNear = getNear;

function getCount(credentials, fields, limit, offset, order, limitExpression) {
  if (offset === void 0) {
    offset = 0;
  }

  if (order === void 0) {
    order = "uuid";
  }

  if (limitExpression === void 0) {
    limitExpression = "";
  }

  return units_1.UnitsCount(limitExpression, credentials).then(function (resp) {
    return resp;
  });
}

exports.getCount = getCount;

function loadFromStorage() {
  return units_2.load();
}

exports.loadFromStorage = loadFromStorage;

function sort(units, field, desc) {
  return units.sort(function (a, b) {
    return compare(a, b, field, desc);
  });
}

exports.sort = sort;

function compare(a, b, field, desc) {
  if (desc) {
    return field.compare(b, a);
  }

  return field.compare(a, b);
}